import {
    USER_LOGIN,
    USER_LOGIN_ERROR,
    USER_LOGOUT_SUCCESS,
    USER_LOGOUT_FAIL,
    USER_REGISTER_FAIL,
    USER_LOADING,
    USER_LOADING_ERROR,
    USER_ACTIVATE_FAIL,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_FAIL,
    USER_DELETE_FAIL
} from "../types/user";

let user_data = sessionStorage.getItem('user_data123x') !== undefined ? JSON.parse(sessionStorage.getItem('user_data123x')) : null;
let auth = sessionStorage.getItem('auth') !== 'undefined' ? JSON.parse(sessionStorage.getItem('auth')) : false;
let active_school = sessionStorage.getItem('active_school') !== undefined ? JSON.parse(sessionStorage.getItem('active_school')) : false;

const initialState = {
    token: sessionStorage.getItem('token'),
    user: user_data && user_data !== undefined && parseInt(user_data.id) > 0 ? user_data: null,
    mid: user_data  && user_data !== undefined && parseInt(user_data.id) > 0 ? user_data.id: null,
    username: user_data  && user_data !== undefined && parseInt(user_data.id) > 0 ? user_data.surname+" "+user_data.firstname+" "+user_data.middlename: null,
    isAuthenticated: auth  && parseInt(auth) === 1 ? true : false,
    isLoading: false,
    schoolId: active_school && parseInt(active_school) > 0 ? active_school : null,
    isEdit:-1,
    msg:'',
    isLogin:0
}


const user_file = function(state = initialState, action){
    switch (action.type) {
        case USER_LOADING:
            return {
                ...state,
                isLoading : true
            };

        case USER_LOGIN: 
            let { surname, firstname, middlename, is_active, schoolid } = action.payload || ''
            
            var newDateObj = new Date().getTime() + (220 * 60 * 1000)
            sessionStorage.removeItem('token')
            sessionStorage.setItem('token', action.token);
            sessionStorage.setItem('tokentime', newDateObj.toString())
            sessionStorage.setItem('auth', JSON.stringify(1));
            sessionStorage.setItem('active_school', JSON.stringify(schoolid));
            if(sessionStorage.getItem('user_data123x') === null || sessionStorage.getItem('user_data123x') === undefined )
            {
                sessionStorage.setItem('user_data123x', JSON.stringify(action.payload));
            }else{
                sessionStorage.removeItem('user_data123x')
            }
            let fname = surname+" "+firstname+" "+middlename
            return {
                ...state,
                isLoading: false,
                isAuthenticated: true,
                mid:action.payload.id,
                user: JSON.parse(sessionStorage.getItem('user_data123x')) ,
                username: fname,
                schoolId: JSON.parse(sessionStorage.getItem('active_school'))
            }; 
        case USER_LOADING_ERROR:
        case USER_ACTIVATE_FAIL:
        case USER_REGISTER_FAIL:
        case USER_DELETE_FAIL:
        case USER_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
       
         case USER_UPDATE_SUCCESS:
            sessionStorage.setItem('user_data123x', JSON.stringify(action.payload));
            
            return {
                ...state,
                ...action.payload,
                user : action.payload
            }; 
        case USER_LOGOUT_SUCCESS:
        case USER_LOGOUT_FAIL:
           
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('tokentime')
            sessionStorage.removeItem('auth')
            sessionStorage.removeItem('user')
            sessionStorage.clear()
            localStorage.clear()
            
            return{
                ...state,
                token: null,
                isRegistered: false,
                isAuthenticated: false,
                isLoading: false,
                user: {},
                isAdmin : null,
                mid:null
            } ;
        case USER_LOGIN_ERROR:
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('tokentime')
                sessionStorage.removeItem('auth')
                sessionStorage.removeItem('user')
                sessionStorage.clear()
                localStorage.clear()
                
                return{
                    ...state,
                    token: null,
                    isRegistered: false,
                    isAuthenticated: false,
                    isLoading: false,
                    user: {},
                    isAdmin : null,
                    mid:null,
                    msg: action.payload,
                    isLogin: 0
                }
        
        default:
            return state;
    }

}
export default user_file